import { Button, Drawer, Table, Space, message, InputNumber, Input } from "antd"
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons"
import React, { useState } from "react"
import { doc, updateDoc } from "firebase/firestore"
import { db } from "../../../firebase/config"

export default function EditTapePriceDrawer({ record, onSuccess }) {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [prices, setPrices] = useState(record.prices || [])

  const showDrawer = () => {
    setPrices(record.prices || [])
    setOpen(true)
  }

  const onClose = () => {
    setOpen(false)
    setPrices(record.prices || [])
  }

  const handleSave = async () => {
    try {
      setLoading(true)

      const docRef = doc(db, "tapePrices", record.id)
      await updateDoc(docRef, {
        prices: prices,
      })

      message.success("Price tiers updated successfully!")
      onClose()
      if (onSuccess) onSuccess()
    } catch (error) {
      console.error("Error updating price:", error)
      message.error("Failed to update price")
    } finally {
      setLoading(false)
    }
  }

  const handlePriceChange = (index, field, value) => {
    const newPrices = [...prices]
    newPrices[index] = { ...newPrices[index], [field]: value }
    setPrices(newPrices)
  }

  const handleAddPrice = () => {
    const newPrice = {
      boxCount: 1,
      label: "",
      price: 0,
      rolls: 0,
      weight: 0,
    }
    setPrices([...prices, newPrice])
  }

  const handleDeletePrice = (index) => {
    setPrices(prices.filter((_, i) => i !== index))
  }

  const priceColumns = [
    {
      title: "Label",
      dataIndex: "label",
      width: "15%",
      render: (text, _, index) => (
        <Input
          value={prices[index].label}
          onChange={(e) => handlePriceChange(index, "label", e.target.value)}
          placeholder="e.g., 40 rolls"
        />
      ),
    },
    {
      title: "Rolls",
      dataIndex: "rolls",
      width: "12%",
      render: (text, _, index) => (
        <InputNumber
          value={prices[index].rolls}
          onChange={(val) => handlePriceChange(index, "rolls", val)}
          min={0}
        />
      ),
    },
    {
      title: "Box Count",
      dataIndex: "boxCount",
      width: "12%",
      render: (text, _, index) => (
        <InputNumber
          value={prices[index].boxCount}
          onChange={(val) => handlePriceChange(index, "boxCount", val)}
          min={0}
        />
      ),
    },
    {
      title: "Price",
      dataIndex: "price",
      width: "15%",
      render: (text, _, index) => (
        <InputNumber
          value={prices[index].price}
          onChange={(val) => handlePriceChange(index, "price", val)}
          min={0}
          step={0.01}
          precision={2}
        />
      ),
    },
    {
      title: "Action",
      width: "18%",
      render: (_, __, index) => (
        <Button
          danger
          size="small"
          icon={<DeleteOutlined />}
          onClick={() => handleDeletePrice(index)}>
          Delete
        </Button>
      ),
    },
  ]

  return (
    <>
      <Button type="primary" size="small" onClick={showDrawer}>
        Edit
      </Button>
      <Drawer
        title={`Edit Price Tiers - ${record.product?.productName || "Unknown"}`}
        placement="right"
        width={700}
        onClose={onClose}
        open={open}
        footer={
          <Space style={{ float: "right" }}>
            <Button onClick={onClose}>Cancel</Button>
            <Button type="primary" loading={loading} onClick={handleSave}>
              Save
            </Button>
          </Space>
        }>
        <Table
          columns={priceColumns}
          dataSource={prices}
          rowKey={(_, index) => index}
          pagination={false}
          size="small"
        />
        <Button
          type="dashed"
          block
          icon={<PlusOutlined />}
          onClick={handleAddPrice}
          style={{ marginTop: 16 }}>
          Add Price Tier
        </Button>
      </Drawer>
    </>
  )
}
